import React, { Fragment } from "react";

import {
  BarChart,
  Bar,
  Cell,
  Tooltip,
  ResponsiveContainer,
  YAxis,
  XAxis
} from "recharts";
import moment from "moment";

import {
  Metric,
  Trend,
  selectFormat,
  StandardTooltip,
  getIcon,
  SOCIALS_COLORS
} from "./../Utils/Utils.js";
import Heading from "../Elements/Heading.js";

const SocialPerformance = props => {
  const data = props.data.table;
  const labels = props.data.labels;

  const previousMonth = moment(labels.previousMonth).format("MMM YYYY");
  const currentMonth = moment(labels.currentMonth).format("MMM YYYY");

  const renderCharts = (data, type) =>
    data.map((chart, i) => (
      <Fragment key={i}>
        <div className="social-performance__legend d-inline d-xl-flex align-items-center">
          <div className="d-flex align-items-center">
            <span className="mt-n1 mr-1">{getIcon(chart.name)}</span>
            <Metric size="xs" type={type} {...chart.total} />
          </div>

          <div className="d-flex mt-1 mb-2 mt-xl-0 mb-xl-0">
            <div className="ml-0 m-xl-1 ml-xl-2 mr-2">
              <Trend size="xs" type={"percentage"} {...chart.mom} label="MOM" />
            </div>

            <div className="ml-0 m-xl-1 ml-xl-2 mr-2">
              <Trend size="xs" type={"percentage"} {...chart.yoy} label="YOY" />
            </div>
          </div>
        </div>

        {chart.data && (
          <ResponsiveContainer height={40}>
            <BarChart
              data={chart.data}
              layout="vertical"
              width={100}
              height={15}
              margin={{ top: 0, right: 0, left: 0, bottom: 10 }}
              barCategoryGap={0}
            >
              <Tooltip
                cursor={{ fill: "#eee", opacity: 0.5 }}
                content={
                  <StandardTooltip
                    render={({ data }) => {
                      // const payload = data(this.props);
                      const payload = chart.data;
                      if (payload !== null) {
                        return (
                          <div className="standard-tooltip">
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                {chart.name}
                              </span>
                            </header>
                            <main className="standard-tooltip__main">
                              <div className="standard-tooltip__item">
                                <span className="standard-tooltip__key">
                                  <span
                                    className="standard-tooltip__icon"
                                    style={{
                                      background:
                                        SOCIALS_COLORS[`${chart.name}`][0]
                                    }}
                                  />
                                  {currentMonth}
                                </span>
                                <span className="standard-tooltip__value">
                                  {selectFormat(type, payload[0].value)}
                                </span>
                              </div>
                              <div className="standard-tooltip__item">
                                <span className="standard-tooltip__key">
                                  <span
                                    className="standard-tooltip__icon"
                                    style={{
                                      background:
                                        SOCIALS_COLORS[`${chart.name}`][1]
                                    }}
                                  />

                                  {previousMonth}
                                </span>
                                <span className="standard-tooltip__value">
                                  {selectFormat(type, payload[1].value)}
                                </span>
                              </div>
                            </main>
                          </div>
                        );
                      }
                    }}
                  />
                }
              />
              <XAxis type="number" hide />
              <YAxis type="category" hide />

              <Bar stackId="stack" dataKey="value">
                {chart.data.map((_, index) => {
                  return (
                    <Cell
                      fill={SOCIALS_COLORS[chart.name][index]}
                      key={index}
                    />
                  );
                })}
              </Bar>

              <Bar stackId="stack" dataKey="total" fill={"#fff"} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </Fragment>
    ));

  const renderHeader = data => (
    <>
      <Heading size={5} className={"mb-2"}>
        {data.label}
      </Heading>
      <div className="d-flex mb-2">
        <div className="mr-2">
          {" "}
          <Metric size="lg" type={data.type} {...data.total} />
        </div>
        <div className="d-flex flex-column mt-1 ml-1">
          <Trend type={"percentage"} label="MOM" {...data.mom} />
          <Trend type={"percentage"} label="YOY" {...data.yoy} />
        </div>
      </div>
      <hr className="social-performance__hr--dotted" />
    </>
  );

  const renderSection = widgets => (
    <div className="row social-performance__separator">
      {widgets.map((data, i) => (
        <div className="col-6 col-lg-3" key={i}>
          <div className="social-performance__widget mt-0 mt-md-2">
            {renderHeader(data)}
            {renderCharts(data.charts, data.type)}
            {(i === 0 || i === 1) && (
              <hr className="social-performance__hr d-block d-md-none" />
            )}
          </div>
        </div>
      ))}
    </div>
  );

  const renderSections = () =>
    data.map((section, i) => {
      let first_row = section.cells.splice(
        0,
        Math.ceil(section.cells.length / 2)
      );
      let second_row = section.cells;
      return (
        <section className="mb-5" key={i}>
          <div className="social-performance__header mb-4 pl-3 pt-2 pb-2">
            <Heading size={4} className={"m-0"}>
              {section.label} &nbsp;
              {/* <small className="opacity-70">{previousMonth} - </small> */}
              <small className="opacity-70">{currentMonth} </small>
            </Heading>
          </div>
          {renderSection(first_row)}
          <hr className="social-performance__hr" />
          {renderSection(second_row)}
        </section>
      );
    });

  return renderSections();
};
export default SocialPerformance;
